import { render } from "./PrintShell.vue?vue&type=template&id=8b7d6fc8&scoped=true"
import script from "./PrintShell.vue?vue&type=script&lang=js"
export * from "./PrintShell.vue?vue&type=script&lang=js"

import "./PrintShell.vue?vue&type=style&index=0&id=8b7d6fc8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7d6fc8"]])

export default __exports__